/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpsertStudySiteIntegrationConfigDto = {
    type: UpsertStudySiteIntegrationConfigDto.type;
    enabled: boolean;
    config: any;
}

export namespace UpsertStudySiteIntegrationConfigDto {

    export enum type {
        VELOCITY = 'velocity',
    }


}
